/**
 * OPT-455: swatches for the price-tag colors the ConsignCloud tag-color sync
 * writes to Inventory.tagColor. Keys must equal TAG_COLORS in
 * amplify/backend/function/consigncloud/src/tag-color-sync.cjs (a test checks).
 * `fg` is white or brand ink (#0F172A), whichever contrasts more (>= 4.5:1).
 */
const W = '#FFFFFF';
const INK = '#0F172A';

export const TAG_COLOR_SWATCHES = Object.freeze({
  Black: { bg: '#1F1F1F', fg: W },
  Blue: { bg: '#2563EB', fg: W },
  Brown: { bg: '#7A4A26', fg: W },
  'Dark Blue': { bg: '#1E3A8A', fg: W },
  'Dark Green': { bg: '#1F5A35', fg: W },
  'Dark Purple': { bg: '#4C1D95', fg: W },
  Green: { bg: '#3FA34D', fg: INK },
  Grey: { bg: '#9CA3AF', fg: INK },
  'Hot Pink': { bg: '#FF2E93', fg: INK },
  'Light Blue': { bg: '#93C5FD', fg: INK },
  'Light Purple': { bg: '#C4B5FD', fg: INK },
  Mint: { bg: '#A7F3D0', fg: INK },
  Orange: { bg: '#F28C28', fg: INK },
  Pink: { bg: '#F9A8D4', fg: INK },
  Purple: { bg: '#7E3AF2', fg: W },
  Red: { bg: '#D62828', fg: W },
  Teal: { bg: '#0F766E', fg: W },
  White: { bg: W, fg: INK },
  Yellow: { bg: '#FFE14D', fg: INK },
});

const BY_KEY = Object.keys(TAG_COLOR_SWATCHES).reduce((m, name) => {
  m[name.toLowerCase()] = name;
  return m;
}, {});

/** { name, bg, fg } for a known tag color (trimmed, case-insensitive), else null. */
export function tagSwatch(name) {
  if (typeof name !== 'string') return null;
  const canonical = BY_KEY[name.trim().toLowerCase()];
  if (!canonical) return null;
  return { name: canonical, ...TAG_COLOR_SWATCHES[canonical] };
}
